export const messages = {
  en: {
    roomList: {
      addBuilding: 'Add Building',
      editBuilding: 'Edit Building',
      deleteBuilding: 'Delete Building',
      selectRoom: 'Select Room',
      addUnit: 'Add Unit',
      editUnit: 'Edit Unit',
      deleteUnit: 'Delete Unit',
      addRoom: 'Add Room',
      importRoom: 'Import Property',
      document: 'Document',
      queryCondition: 'Query Condition',
      roomIdPlaceholder: 'Please fill in room number format: Building-Unit-Room',
      selectState: 'Select Status',
      selectRoomType: 'Required, select room type',
      query: 'Query',
      reset: 'Reset',
      room: 'Room',
      floor: 'Floor',
      owner: 'Owner',
      type: 'Type',
      area: 'Building/Indoor Area',
      rent: 'Rent',
      roomStatus: 'Room Status',
      validity: 'Validity Period',
      ownerMembers: 'Owner Members',
      ownerCars: 'Owner Vehicles',
      ownerRooms: 'Owner Rooms',
      complaints: 'Complaints',
      repairs: 'Repairs',
      roomOweFee: 'Room Arrears',
      ownerOweFee: 'Owner Arrears',
      roomContracts: 'Room Contracts',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      handOver: 'Hand Over',
      checkOut: 'Check Out',
      businessAcceptance: 'Business Acceptance',
      layer: 'Layer',
      squareMeter: 'm²',
      roomStatusDesc1: 'Room status is divided into: unsold, unoccupied, handed over, decorated, occupied, etc.',
      roomStatusDesc2: '1. Unsold means there is no relationship between the room and the owner, so the status cannot be manually modified. It needs to be changed to occupied by the owner moving in.',
      roomStatusDesc3: '2. Unoccupied, handed over, decorated, and occupied status indicate that there is a relationship between the owner and the room. They can be modified mutually, mainly used to create different fees based on different status when creating room fees.',
      rentDesc: 'Rent: Mainly used for park-type properties or properties with many rented rooms, residential properties can ignore this.'
    },
    room: {
      floorUnitTree: {
        building: 'Building',
        unit: 'Unit',
        noData: 'No buildings currently'
      },
      searchFloor: {
        title: 'Building Search',
        placeholder: {
          floorId: 'Please enter building ID',
          floorName: 'Please enter building name',
          floorNum: 'Please enter building number'
        },
        table: {
          floorId: 'Building ID',
          floorName: 'Name',
          floorNum: 'Number',
          creator: 'Creator',
          actions: 'Actions'
        }
      },
      editRoom: {
        title: 'Edit Room',
        roomNum: 'Room Number',
        layer: 'Floor',
        unit: 'Unit',
        roomType: 'Room Type',
        apartment1: 'Bedrooms',
        apartment2: 'Living Rooms',
        builtUpArea: 'Built-up Area (m²)',
        roomArea: 'Indoor Area (m²)',
        feeCoefficient: 'Fee Coefficient',
        roomRent: 'Rent',
        roomState: 'Room State',
        endTime: 'End Time',
        remark: 'Remark',
        placeholder: {
          roomNum: 'Required, please enter room number',
          layer: 'Required, please enter floor',
          unit: 'Required, please select unit',
          roomType: 'Required, please select room type',
          apartment: 'Required, please select apartment layout',
          builtUpArea: 'Required, please enter built-up area! m²',
          roomArea: 'Required, please enter indoor area! m²',
          feeCoefficient: 'Please enter fee coefficient',
          roomRent: 'Required, please enter rent',
          roomState: 'Required, please select room state',
          endTime: 'Required, please select end time',
          remark: 'Please enter remark information'
        },
        apartment1Options: {
          oneRoom: 'One Bedroom',
          twoRooms: 'Two Bedrooms',
          threeRooms: 'Three Bedrooms',
          fourRooms: 'Four Bedrooms',
          fiveRooms: 'Five Bedrooms',
          sixRooms: 'Six Bedrooms',
          sevenRooms: 'Seven Bedrooms',
          eightRooms: 'Eight Bedrooms'
        },
        apartment2Options: {
          oneHall: 'One Living Room',
          twoHalls: 'Two Living Rooms',
          threeHalls: 'Three Living Rooms',
          fourHalls: 'Four Living Rooms',
          fiveHalls: 'Five Living Rooms',
          sixHalls: 'Six Living Rooms',
          sevenHalls: 'Seven Living Rooms',
          eightHalls: 'Eight Living Rooms'
        },
        roomStateOptions: {
          occupied: 'Occupied',
          delivered: 'Delivered',
          decorated: 'Decorated',
          vacant: 'Vacant',
          decorating: 'Decorating'
        }
      },
      deleteRoom: {
        title: 'Confirm Operation',
        confirmMessage: 'Confirm deletion! Deleting a room will delete associated fees and payment records, and automatically unbind owners!'
      },
      importOwnerRoom: {
        title: 'Property Import',
        selectFile: 'Select File',
        clickUpload: 'Click to upload',
        requiredFile: 'Required, please select data file',
        downloadTemplate: 'Download Template',
        downloadFirst: 'Please download first',
        propertyTemplate: 'Property Template',
        prepareData: 'to prepare data, then upload for import',
        fileRequired: 'File cannot be empty',
        invalidFormat: 'Invalid Excel format',
        fileSizeExceeded: 'Excel file size cannot exceed 2MB',
        importSuccess: 'Import successful',
        importFailed: 'Import failed',
        importError: 'Import error occurred'
      },
      addFloor: {
        title: 'Add Building',
        floorNum: 'Building Number',
        name: 'Building Name',
        floorArea: 'Floor Area',
        seq: 'Sequence',
        remark: 'Remark',
        buildingSuffix: ' Building',
        floorNumPlaceholder: 'Required, please enter number',
        namePlaceholder: 'Required, please enter name',
        floorAreaPlaceholder: 'Required, please enter floor area',
        remarkPlaceholder: 'Optional, please enter remark',
        floorNumRequired: 'Building number is required',
        floorNumLength: 'Building number must be 1-64 characters',
        nameRequired: 'Building name is required',
        nameLength: 'Building name must be 2-64 characters',
        floorAreaRequired: 'Floor area is required',
        floorAreaFormat: 'Invalid floor area format, e.g. 300.00',
        seqRequired: 'Sequence is required',
        seqNumber: 'Sequence must be a number',
        remarkMaxLength: 'Remark cannot exceed 200 characters',
        saveSuccess: 'Add successful',
        saveFailed: 'Add failed',
        saveError: 'Error adding building'
      },
      editFloor: {
        title: 'Edit Building',
        floorNum: 'Building Number',
        floorName: 'Building Name',
        floorArea: 'Floor Area',
        seq: 'Sequence',
        remark: 'Remark',
        floorNumPlaceholder: 'Required, please enter number',
        floorNamePlaceholder: 'Required, please enter name',
        floorAreaPlaceholder: 'Required, please enter floor area',
        remarkPlaceholder: 'Optional, please enter remark',
        floorNumRequired: 'Building number is required',
        floorNumLength: 'Building number must be 1-64 characters',
        floorNameRequired: 'Building name is required',
        floorNameLength: 'Building name must be 2-64 characters',
        floorAreaRequired: 'Floor area is required',
        floorAreaFormat: 'Invalid floor area format, e.g. 300.00',
        seqRequired: 'Sequence is required',
        seqNumber: 'Sequence must be a number',
        remarkMaxLength: 'Remark cannot exceed 200 characters',
        updateSuccess: 'Update successful',
        updateFailed: 'Update failed',
        updateError: 'Error updating building'
      },
      deleteFloor: {
        title: 'Confirm Operation',
        confirmMessage: 'Are you sure you want to delete?',
        cancelText: 'Cancel',
        confirmDelete: 'Confirm Delete',
        deleteSuccess: 'Delete successful',
        deleteFailed: 'Delete failed',
        deleteError: 'Error deleting building'
      }
    },
    ownerRooms: {
      title: 'Owner Rooms',
      roomId: 'Room ID',
      layer: 'Floor',
      type: 'Type',
      area: 'Built/Indoor Area',
      rent: 'Rent',
      status: 'Room Status',
      oweFee: 'Owed Fee',
      updateDaily: 'Updated daily',
      subtotal: 'Subtotal of owed fees',
      successMessage: 'Data loaded successfully',
      errorMessage: 'Failed to load data'
    },
    ownerMembers: {
      title: 'Owner Members',
      name: 'Name',
      sex: 'Gender',
      male: 'Male',
      female: 'Female',
      age: 'Age',
      type: 'Type',
      idCard: 'ID Card',
      contact: 'Contact',
      address: 'Address'
    },
    ownerCars: {
      title: 'Owner Cars',
      licensePlate: 'License Plate',
      licenseType: 'License Type',
      temporary: 'Temporary Car',
      carType: 'Car Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      park: ' Park',
      space: ' Space',
      released: 'Space Released',
      validity: 'Validity Period'
    },
    ownerComplaints: {
      title: 'Owner Complaints',
      type: 'Type',
      room: 'Room',
      contact: 'Contact',
      phone: 'Phone',
      status: 'Status',
      handler: 'Handler',
      handlerPhone: 'Handler Phone',
      createTime: 'Create Time',
      none: 'None'
    },
    ownerRepairs: {
      title: 'Owner Repairs',
      workOrder: 'Work Order ID',
      location: 'Location',
      repairType: 'Repair Type',
      reporter: 'Reporter',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      status: 'Status',
      taskProcessed: '(Task Processed)'
    },
    ownerOweFees: {
      title: 'Owner Arrears',
      payerObj: 'Charge Object',
      ownerName: 'Owner Name',
      phone: 'Phone',
      startTime: 'Start Time',
      endTime: 'End Time',
      total: 'Total',
      unit: 'Unit: Yuan',
      updateTime: 'Update Time'
    },
    ownerOweFeesDemo: {
      openBtn: 'View Owner Arrears'
    },
    roomOweFees: {
      title: 'Room Arrears',
      payerObj: 'Charge Object',
      ownerName: 'Owner Name',
      phone: 'Phone',
      startTime: 'Start Time',
      endTime: 'End Time',
      total: 'Total',
      unit: 'Unit: Yuan',
      updateTime: 'Update Time'
    },
    roomOweFeesDemo: {
      openBtn: 'View Room Arrears'
    },
    roomContracts: {
      title: 'Room Contracts',
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      parentContractCode: 'Parent Contract Code',
      contractType: 'Contract Type',
      operator: 'Operator',
      amount: 'Contract Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Draft Time',
      state: 'Status'
    },
    roomContractsDemo: {
      openByOwner: 'Open by Owner',
      openByRoom: 'Open by Room'

    },
    addUnit: {
      title: 'Add Unit',
      unitNum: 'Unit Number',
      unitNumPlaceholder: 'Required, please enter unit number',
      layerCount: 'Total Floors',
      layerCountPlaceholder: 'Required, please enter total floors',
      unitArea: 'Building Area',
      unitAreaPlaceholder: 'Required, please enter building area',
      lift: 'Elevator',
      liftPlaceholder: 'Required, please select elevator availability',
      liftOption1: 'Yes',
      liftOption2: 'No',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remarks',
      save: 'Save',
      cancel: 'Cancel',
      zeroUnitWarning: 'Unit 0 is specific to shops and cannot be added',
      successMessage: 'Unit added successfully',
      errorMessage: 'Failed to add unit'
    },
    editUnit: {
      title: 'Edit Unit',
      unitNum: 'Unit Number',
      unitNumPlaceholder: 'Required, please enter unit number',
      layerCount: 'Total Floors',
      layerCountPlaceholder: 'Required, please enter total floors',
      unitArea: 'Building Area',
      unitAreaPlaceholder: 'Required, please enter building area',
      lift: 'Elevator',
      liftPlaceholder: 'Required, please select elevator availability',
      liftOption1: 'Yes',
      liftOption2: 'No',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remarks',
      save: 'Save',
      cancel: 'Cancel',
      zeroUnitWarning: 'Unit 0 is specific to shops and cannot be edited',
      successMessage: 'Unit updated successfully',
      errorMessage: 'Failed to update unit'
    },
    deleteUnit: {
      title: 'Confirm Operation',
      confirmMessage: 'Are you sure you want to delete this unit?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      successMessage: 'Unit deleted successfully',
      errorMessage: 'Failed to delete unit'
    },
    searchRoom: {
      title: 'Select Room',
      floorNumPlaceholder: 'Enter building number',
      roomNumPlaceholder: 'Enter room number',
      search: 'Search',
      reset: 'Reset',
      roomId: 'Room ID',
      floorNum: 'Building Number',
      unitNum: 'Unit Number',
      roomNum: 'Room Number',
      layer: 'Floor',
      operation: 'Operation',
      choose: 'Choose',
      building: 'Building',
      unit: 'Unit',
      room: 'Room',
      floor: 'Floor',
      loadFailed: 'Failed to load room information'
    }
  },
  zh: {
    roomList: {
      addBuilding: '添加楼栋',
      editBuilding: '修改楼栋',
      deleteBuilding: '删除楼栋',
      selectRoom: '选择房屋',
      addUnit: '添加单元',
      editUnit: '修改单元',
      deleteUnit: '删除单元',
      addRoom: '添加房屋',
      importRoom: '房产导入',
      document: '文档',
      queryCondition: '查询条件',
      roomIdPlaceholder: '请填写房屋编号 格式 楼栋-单元-房屋',
      selectState: '请选择状态',
      selectRoomType: '必填，请选择房屋类型',
      query: '查询',
      reset: '重置',
      room: '房屋',
      floor: '楼层',
      owner: '业主',
      type: '类型',
      area: '建筑/室内面积',
      rent: '租金',
      roomStatus: '房屋状态',
      validity: '有效期',
      ownerMembers: '业主成员',
      ownerCars: '业主车辆',
      ownerRooms: '业主房屋',
      complaints: '投诉',
      repairs: '报修',
      roomOweFee: '房屋欠费',
      ownerOweFee: '业主欠费',
      roomContracts: '房屋合同',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      handOver: '交房',
      checkOut: '退房',
      businessAcceptance: '业务受理',
      layer: '层',
      squareMeter: '平方米',
      roomStatusDesc1: '房屋状态 分为：未销售，未入住，已交房，已装修，已入住 等状态',
      roomStatusDesc2: '1、未销售表示 房屋和业主之间还没有任何关系，所以修改时状态不能手工修改 需要业主入住房屋的方式 将未销售改为已入住',
      roomStatusDesc3: '2、未入住 已交房 已装修 已入住 状态表示业主和房屋之间已经有关系 可以相互修改，主要作用为在房屋创建费用时根据不同的状态去创建不同的费用',
      rentDesc: '租金：主要用于园区类或者房屋出租比较多的物业使用，小区物业忽略'
    },
    room: {
      floorUnitTree: {
        building: '栋',
        unit: '单元',
        noData: '当前没有楼栋'
      },
      searchFloor: {
        title: '小区楼',
        placeholder: {
          floorId: '请输入楼栋ID',
          floorName: '请输入楼栋名称',
          floorNum: '请输入楼栋编号'
        },
        table: {
          floorId: '楼ID',
          floorName: '名称',
          floorNum: '编号',
          creator: '创建人',
          actions: '操作'
        }
      },
      editRoom: {
        title: '修改房屋',
        roomNum: '房屋编号',
        layer: '房屋楼层',
        unit: '房屋单元',
        roomType: '房屋类型',
        apartment1: '户型室',
        apartment2: '户型厅',
        builtUpArea: '建筑面积(平方)',
        roomArea: '室内面积(平方)',
        feeCoefficient: '算费系数',
        roomRent: '租金',
        roomState: '房屋状态',
        endTime: '结束时间',
        remark: '备注',
        placeholder: {
          roomNum: '必填，请填写房屋编号',
          layer: '必填，请填写房屋楼层',
          unit: '必填，请选择单元',
          roomType: '必填，请选择房屋类型',
          apartment: '必填，请选择房屋户型',
          builtUpArea: '必填，请填写房屋建筑面积! 平方',
          roomArea: '必填，请填写室内面积! 平方',
          feeCoefficient: '请填写算费系数',
          roomRent: '必填，请填写租金',
          roomState: '必填，请选择房屋状态',
          endTime: '必填，请选择结束时间',
          remark: '请填写备注信息'
        },
        apartment1Options: {
          oneRoom: '一室',
          twoRooms: '两室',
          threeRooms: '三室',
          fourRooms: '四室',
          fiveRooms: '五室',
          sixRooms: '六室',
          sevenRooms: '七室',
          eightRooms: '八室'
        },
        apartment2Options: {
          oneHall: '一厅',
          twoHalls: '两厅',
          threeHalls: '三厅',
          fourHalls: '四厅',
          fiveHalls: '五厅',
          sixHalls: '六厅',
          sevenHalls: '七厅',
          eightHalls: '八厅'
        },
        roomStateOptions: {
          occupied: '已入住',
          delivered: '已交房',
          decorated: '已装修',
          vacant: '未入住',
          decorating: '装修中'
        }
      },
      deleteRoom: {
        title: '请确认您的操作',
        confirmMessage: '确认是否删除! 删除房屋会关联删除房屋下的费用以及缴费记录，并且自动解绑业主！'
      },
      importOwnerRoom: {
        title: '房产导入',
        selectFile: '选择文件',
        clickUpload: '点击上传',
        requiredFile: '必填，请选择数据文件',
        downloadTemplate: '下载模板',
        downloadFirst: '请先下载',
        propertyTemplate: '房产模板',
        prepareData: '准备数据后，上传导入',
        fileRequired: '文件不能为空',
        invalidFormat: '不是有效的Excel格式',
        fileSizeExceeded: 'Excel文件大小不能超过2M',
        importSuccess: '导入成功',
        importFailed: '导入失败',
        importError: '导入出错'
      },
      addFloor: {
        title: '添加楼栋',
        floorNum: '楼栋编号',
        name: '楼栋名称',
        floorArea: '建筑面积',
        seq: '排序',
        remark: '备注',
        buildingSuffix: '号楼',
        floorNumPlaceholder: '必填，请填写编号',
        namePlaceholder: '必填，请填写名称',
        floorAreaPlaceholder: '必填，请填写建筑面积',
        remarkPlaceholder: '可填，请填写备注',
        floorNumRequired: '楼栋编号不能为空',
        floorNumLength: '楼栋编号长度必须在1位至64位',
        nameRequired: '楼栋名称不能为空',
        nameLength: '楼栋名称长度必须在2位至64位',
        floorAreaRequired: '建筑面积不能为空',
        floorAreaFormat: '建筑面积错误，如300.00',
        seqRequired: '排序不能为空',
        seqNumber: '排序必须是数字',
        remarkMaxLength: '备注长度不能超过200位',
        saveSuccess: '添加成功',
        saveFailed: '添加失败',
        saveError: '添加楼栋出错'
      },
      editFloor: {
        title: '修改楼栋',
        floorNum: '楼栋编号',
        floorName: '楼栋名称',
        floorArea: '建筑面积',
        seq: '排序',
        remark: '备注',
        floorNumPlaceholder: '必填，请填写编号',
        floorNamePlaceholder: '必填，请填写名称',
        floorAreaPlaceholder: '必填，请填写建筑面积',
        remarkPlaceholder: '可填，请填写备注',
        floorNumRequired: '楼栋编号不能为空',
        floorNumLength: '楼栋编号长度必须在1位至64位',
        floorNameRequired: '楼栋名称不能为空',
        floorNameLength: '楼栋名称长度必须在2位至64位',
        floorAreaRequired: '建筑面积不能为空',
        floorAreaFormat: '建筑面积错误，如300.00',
        seqRequired: '排序不能为空',
        seqNumber: '排序必须是数字',
        remarkMaxLength: '备注长度不能超过200位',
        updateSuccess: '修改成功',
        updateFailed: '修改失败',
        updateError: '修改楼栋出错'
      },
      deleteFloor: {
        title: '请确认您的操作',
        confirmMessage: '确认是否删除？',
        cancelText: '点错了',
        confirmDelete: '确认删除',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        deleteError: '删除楼栋出错'
      },
    },
    ownerRooms: {
      title: '业主房屋',
      roomId: '房屋ID',
      layer: '楼层',
      type: '类型',
      area: '建筑/室内面积',
      rent: '租金',
      status: '房屋状态',
      oweFee: '房屋欠费',
      updateDaily: '按天更新',
      subtotal: '欠费小计',
      successMessage: '数据加载成功',
      errorMessage: '加载数据失败'
    },
    ownerMembers: {
      title: '业主成员',
      name: '名称',
      sex: '性别',
      male: '男',
      female: '女',
      age: '年龄',
      type: '类型',
      idCard: '身份证',
      contact: '联系方式',
      address: '家庭住址'
    },
    ownerCars: {
      title: '业主车辆',
      licensePlate: '车牌号',
      licenseType: '车牌类型',
      temporary: '临时车',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      park: '车场',
      space: '车位',
      released: '车位已释放',
      validity: '有效期'
    },
    ownerComplaints: {
      title: '业主投诉',
      type: '类型',
      room: '房屋',
      contact: '联系人',
      phone: '联系电话',
      status: '状态',
      handler: '处理人',
      handlerPhone: '处理人电话',
      createTime: '创建时间',
      none: '无'
    },
    ownerRepairs: {
      title: '业主报修',
      workOrder: '工单编码',
      location: '位置',
      repairType: '报修类型',
      reporter: '报修人',
      contact: '联系方式',
      appointmentTime: '报修时间',
      status: '状态',
      taskProcessed: '(定时任务处理)'
    },
    ownerOweFees: {
      title: '业主欠费',
      payerObj: '收费对象',
      ownerName: '业主名称',
      phone: '手机号',
      startTime: '开始时间',
      endTime: '结束时间',
      total: '合计',
      unit: '单位:元',
      updateTime: '更新时间'
    },
    ownerOweFeesDemo: {
      openBtn: '查看业主欠费'
    },
    roomOweFees: {
      title: '房屋欠费',
      payerObj: '收费对象',
      ownerName: '业主名称',
      phone: '手机号',
      startTime: '开始时间',
      endTime: '结束时间',
      total: '合计',
      unit: '单位:元',
      updateTime: '更新时间'
    },
    roomOweFeesDemo: {
      openBtn: '查看房屋欠费'
    },
    roomContracts: {
      title: '房屋合同',
      contractName: '合同名称',
      contractCode: '合同编号',
      parentContractCode: '父合同编号',
      contractType: '合同类型',
      operator: '经办人',
      amount: '合同金额',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '起草时间',
      state: '状态'
    },
    roomContractsDemo: {
      openByOwner: '按业主打开',
      openByRoom: '按房屋打开'
    }
    ,
    addUnit: {
      title: '添加单元',
      unitNum: '单元编号',
      unitNumPlaceholder: '必填，请填写单元编号',
      layerCount: '总层数',
      layerCountPlaceholder: '必填，请填写单元总层数',
      unitArea: '建筑面积',
      unitAreaPlaceholder: '必填，请填写建筑面积',
      lift: '电梯',
      liftPlaceholder: '必填，请选择是否有电梯',
      liftOption1: '有',
      liftOption2: '无',
      remark: '备注',
      remarkPlaceholder: '请填写备注信息',
      save: '保存',
      cancel: '取消',
      zeroUnitWarning: '0单元为商铺特有，不允许添加',
      successMessage: '单元添加成功',
      errorMessage: '添加单元失败'
    },
    editUnit: {
      title: '修改单元',
      unitNum: '单元编号',
      unitNumPlaceholder: '必填，请填写单元编号',
      layerCount: '总层数',
      layerCountPlaceholder: '必填，请填写单元总层数',
      unitArea: '建筑面积',
      unitAreaPlaceholder: '必填，请填写建筑面积',
      lift: '电梯',
      liftPlaceholder: '必填，请选择是否有电梯',
      liftOption1: '有',
      liftOption2: '无',
      remark: '备注',
      remarkPlaceholder: '请填写备注信息',
      save: '保存',
      cancel: '取消',
      zeroUnitWarning: '0单元为商铺特有，不允许修改',
      successMessage: '单元修改成功',
      errorMessage: '修改单元失败'
    },
    deleteUnit: {
      title: '请确认您的操作',
      confirmMessage: '确定删除小区单元',
      cancel: '点错了',
      confirm: '确认删除',
      successMessage: '单元删除成功',
      errorMessage: '删除单元失败'
    },
    searchRoom: {
      title: '选择房屋',
      floorNumPlaceholder: '输入小区楼编号',
      roomNumPlaceholder: '输入房屋编号',
      search: '查询',
      reset: '重置',
      roomId: '房屋ID',
      floorNum: '楼栋编号',
      unitNum: '单元编号',
      roomNum: '房屋编号',
      layer: '楼层',
      operation: '操作',
      choose: '选择',
      building: '号楼',
      unit: '单元',
      room: '室',
      floor: '层',
      loadFailed: '加载房屋信息失败'
    },
    handover: {
      ownerInfo: '业主信息',
      select: '选择业主',
      back: '返回',
      name: '姓名',
      namePlaceholder: '请输入姓名',
      gender: '性别',
      genderPlaceholder: '请选择性别',
      male: '男',
      female: '女',
      age: '年龄',
      agePlaceholder: '请输入年龄',
      idCard: '身份证',
      idCardPlaceholder: '请输入身份证号',
      phone: '联系电话',
      phonePlaceholder: '请输入联系电话',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      houseInfo: '房屋信息',
      selectHouse: '选择房屋',
      editUnit: '修改单元',
      addRoom: '添加房屋',
      createFee: '创建费用',
      house: '房屋',
      area: '面积',
      squareMeter: '平方米',
      houseStatus: '房屋状态',
      operation: '操作',
      delete: '删除',
      feeInfo: '费用信息',
      feeItem: '费用项目',
      startTime: '开始时间',
      endTime: '结束时间',
      submit: '提交',
      submitSuccess: '提交成功',
      submitError: '提交失败',
      houseNotUnsold: '房屋状态不为可交房状态',
      fetchRoomError: '获取房屋信息失败'
    }
  }
}